var _feMorphology, _feOffset, _feGaussianBlur, _feComposite, _feColorMatrix, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgAiButtonSubtitlesOn(props) {
  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-35.7%",
    y: "-45.5%",
    width: "171.4%",
    height: "190.9%",
    filterUnits: "objectBoundingBox",
    id: _id
  }, _feMorphology || (_feMorphology = /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549 0 0 0 0 0.611764706 0 0 0 0 0.91372549 0 0 0 0.69 0",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.281 19.017c.412 0 .746.334.746.746s.334.745.746.745h3.038c.418 0 .757.335.757.746a.752.752 0 01-.757.746H7.189a.752.752 0 01-.757-.746c0-.411.34-.746.757-.746h3.038a.746.746 0 00.746-.745c0-.412.334-.746.746-.746zM27 0a1 1 0 011 1v16.271a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1zm-1.514 1.492H2.514a1 1 0 00-1 1V15.78a1 1 0 001 1h22.972a1 1 0 001-1V2.492a1 1 0 00-1-1zm-2.405 12.305c.418 0 .757.334.757.745a.752.752 0 01-.757.746H14a.752.752 0 01-.757-.746c0-.411.34-.745.757-.745h9.081zm-12.108 0c.418 0 .757.334.757.745a.752.752 0 01-.757.746H4.919a.752.752 0 01-.757-.746c0-.411.34-.745.757-.745h6.054zm12.108-2.983c.418 0 .757.334.757.745a.752.752 0 01-.757.746h-3.027a.752.752 0 01-.757-.746c0-.411.34-.745.757-.745h3.027zm-15.135 0c.418 0 .757.334.757.745a.752.752 0 01-.757.746H4.919a.752.752 0 01-.757-.746c0-.411.34-.745.757-.745h3.027zm9.081 0c.418 0 .757.334.757.745a.752.752 0 01-.757.746h-6.054a.752.752 0 01-.757-.746c0-.411.34-.745.757-.745h6.054z",
    id: _id2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 15)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#".concat(_id, ")"),
    xlinkHref: "#".concat(_id2)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D9CE9",
    d: "M16.281 18.517a1.242 1.242 0 011.246 1.246l3.284.245c.346 0 .659.14.886.363a1.236 1.236 0 01.059 1.705c-.203.229-.49.384-.813.417L7.189 22.5c-.346 0-.659-.139-.886-.362a1.236 1.236 0 01-.059-1.705c.203-.229.49-.384.813-.418l3.17-.007c.246-.559.362-.845.553-1.064.201-.23.486-.386.808-.42zM27-.5A1.498 1.498 0 0128.473.714l.02.143.007 16.414a1.498 1.498 0 01-1.214 1.473l-.143.02L1 18.771a1.498 1.498 0 01-1.473-1.214l-.02-.143L-.5 1A1.498 1.498 0 01.714-.473l.143-.02L27-.5zm-1.514 2.492L2.014 2.52l.528 13.76 23.444-.53-.5-13.758zm-2.405 11.305c.346 0 .66.138.886.362a1.236 1.236 0 010 1.767 1.258 1.258 0 01-.74.354l-.146.008H14a1.26 1.26 0 01-.886-.362 1.236 1.236 0 010-1.767c.194-.192.452-.321.74-.354l.146-.008h9.081zm-12.108 0c.346 0 .66.138.886.362a1.236 1.236 0 010 1.767 1.258 1.258 0 01-.74.354l-.146.008H4.919a1.26 1.26 0 01-.886-.362 1.236 1.236 0 010-1.767c.194-.192.452-.321.74-.354l.146-.008h6.054zm12.108-2.983c.346 0 .66.138.886.362a1.236 1.236 0 010 1.767 1.258 1.258 0 01-.74.354l-.146.008h-3.027a1.26 1.26 0 01-.886-.362 1.236 1.236 0 010-1.767c.194-.192.452-.321.74-.354l.146-.008h3.027zm-15.135 0c.346 0 .66.138.886.362a1.236 1.236 0 010 1.767 1.258 1.258 0 01-.74.354l-.146.008H4.919a1.26 1.26 0 01-.886-.362 1.236 1.236 0 010-1.767c.194-.192.452-.321.74-.354l.146-.008h3.027zm9.081 0c.346 0 .66.138.886.362a1.236 1.236 0 010 1.767 1.258 1.258 0 01-.74.354l-.146.008h-6.054a1.26 1.26 0 01-.886-.362 1.236 1.236 0 010-1.767c.194-.192.452-.321.74-.354l.146-.008h6.054z",
    fill: "#EDF8FF",
    fillRule: "evenodd"
  }))));
}

export default SvgAiButtonSubtitlesOn;